import ResourcesAndTools from 'pages/resources-and-tools/ResourcesAndTools.vue';
import OgdenTable from 'pages/resources-and-tools/OgdenTable.vue';
import Documents from 'pages/resources-and-tools/Documents.vue';

export default [
    {
        name: 'resources-and-tools',
        path: '/resources-and-tools/',
        component: ResourcesAndTools,
        children: [
            {
                name: 'ogden-table',
                path: 'ogden-table-viewer',
                component: OgdenTable
            },
            {
                name: 'at-a-glance',
                path: 'at-a-glance-viewer',
                component: OgdenTable
            },
            {
                name: 'randt::documents',
                path: 'documents',
                component: Documents
            },
        ],

    },
];



// WEBPACK FOOTER //
// ./src/pages/resources-and-tools/routes.js